import { Component, OnInit, OnChanges, SimpleChanges, input, output, signal, ElementRef, HostListener } from '@angular/core';
import { CountryCode } from '../../core/models/data/country-code.model';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ms-country-code-dropdown',
  imports: [CommonModule],
  templateUrl: './country-code-dropdown.component.html',
  styleUrl: './country-code-dropdown.component.scss'
})
export class CountryCodeDropdown implements OnInit, OnChanges {
  
  public countryCodes: CountryCode[] = [
    { code: 'US', name: 'United States', dialCode: '1', flag: 'usa' },
    { code: 'CA', name: 'Canada', dialCode: '1', flag: 'can' },
    { code: 'GB', name: 'United Kingdom', dialCode: '44', flag: 'gbr' },
    { code: 'MX', name: 'México', dialCode: '52', flag: 'mex' },
    { code: 'CR', name: 'Costa Rica', dialCode: '506', flag: 'cri' },
    { code: 'DO', name: 'Dominican Republic', dialCode: '1', flag: 'dom' },
    { code: 'BS', name: 'Bahamas', dialCode: '1', flag: 'bhs' },
    { code: 'VG', name: 'British Virgin Islands', dialCode: '1', flag: 'vgb' },
    { code: 'KY', name: 'Cayman Islands', dialCode: '1', flag: 'cym' },
  ];
  
  public selectedCountryCode = input<string>('1');
  public countryCodeChange = output<string>();
  public selectedCountry: CountryCode = this.countryCodes[0];
  public showDropdown = signal<boolean>(false);

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:keydown.escape')
  onEscapePress(): void {
    this.showDropdown.set(false);
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event): void {
    const target = event.target as Node | null;
    if (!target || !this.elementRef.nativeElement.contains(target)) {
      this.showDropdown.set(false);
    }
  }

  public toggleDropdown(): void {
    this.showDropdown.update(open => !open);
  }

  public ngOnInit() {
    this.updateSelectedCountryFromInput();
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedCountryCode']) {
      this.updateSelectedCountryFromInput();
    }
  }

  private updateSelectedCountryFromInput() {
    const countryCode = this.selectedCountryCode();
    const country = this.findCountryByDialCode(countryCode);
    if (country) {
      this.selectedCountry = country;
    }
  }

  private findCountryByDialCode(dialCode: string): CountryCode | undefined {
    return this.countryCodes.find(country => country.dialCode === dialCode);
  }
  
  public selectCountry(country: CountryCode) {
    this.selectedCountry = country;
    this.countryCodeChange.emit(country.dialCode);
    this.showDropdown.set(false);
  }
}
